const equipamentoMixin = {
  methods: {
    getConfigValue(config, name, property, defaultValue = null) {
      return (
        config.find((e) => e.configName === name)?.config?.value?.[property] ??
        defaultValue
      )
    },
  },
}

export default equipamentoMixin
